import React from 'react';

export const CalendarIcon = () => (
	<svg
		width="100%"
		height="100%"
		viewBox="0 0 139 150"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
	>
		<path
			d="M138.057 26.4478C138.057 19.0046 131.991 12.9649 124.496 12.9649H13.5603C6.06602 12.9649 0 18.9963 0 26.4478V57.039H138.057V26.4478Z"
			fill="#40AF0C"
		/>
		<path
			d="M0 57.0305V136.24C0 143.683 6.06602 149.723 13.5603 149.723H124.505C131.991 149.723 138.065 143.692 138.065 136.24V57.0305H0Z"
			fill="#EEEEF3"
		/>
		<path
			d="M23.6593 0H18.383C16.3182 0 14.6443 1.66433 14.6443 3.7174V29.7475C14.6443 31.8006 16.3182 33.4649 18.383 33.4649H23.6593C25.7242 33.4649 27.3981 31.8006 27.3981 29.7475V3.7174C27.3981 1.66433 25.7242 0 23.6593 0Z"
			fill="#000A23"
		/>
		<path
			d="M119.928 0H114.651C112.586 0 110.913 1.66433 110.913 3.7174V29.7475C110.913 31.8006 112.586 33.4649 114.651 33.4649H119.928C121.992 33.4649 123.666 31.8006 123.666 29.7475V3.7174C123.666 1.66433 121.992 0 119.928 0Z"
			fill="#000A23"
		/>
		<path
			d="M88.2384 0H82.9621C80.8973 0 79.2234 1.66433 79.2234 3.7174V29.7475C79.2234 31.8006 80.8973 33.4649 82.9621 33.4649H88.2384C90.3033 33.4649 91.9771 31.8006 91.9771 29.7475V3.7174C91.9771 1.66433 90.3033 0 88.2384 0Z"
			fill="#000A23"
		/>
		<path
			d="M56.5489 0H51.2727C49.2078 0 47.5339 1.66433 47.5339 3.7174V29.7475C47.5339 31.8006 49.2078 33.4649 51.2727 33.4649H56.5489C58.6138 33.4649 60.2877 31.8006 60.2877 29.7475V3.7174C60.2877 1.66433 58.6138 0 56.5489 0Z"
			fill="#000A23"
		/>
		<path
			d="M50.0548 116.868L30.9032 106.427C29.461 105.619 28.9995 105.1 28.9995 103.542V100.658C28.9995 99.1004 29.461 98.5236 30.9032 97.716L50.0548 87.3325C51.8431 86.3519 52.4776 87.0441 52.4776 89.1208V92.755C52.4776 95.2932 52.0162 95.7546 50.401 96.5622L39.7291 101.812V102.1L50.3433 107.292C52.0162 108.099 52.4776 108.503 52.4776 111.099V115.079C52.4776 117.156 51.8431 117.848 50.0548 116.868ZM58.0867 124.367C56.5292 124.367 56.2407 123.79 56.7022 122.405L71.8159 81.8524C72.4504 80.2949 73.085 79.8911 74.6425 79.8911H79.2574C80.8149 79.8911 81.1033 80.4679 80.6418 81.8524L65.5282 122.405C64.9513 123.963 64.3167 124.367 62.7015 124.367H58.0867ZM87.2559 116.81C85.4676 117.791 84.8331 117.098 84.8331 115.022V111.33C84.8331 108.792 85.2945 108.33 86.9098 107.523L97.5816 102.273V101.985L86.9674 96.793C85.2945 95.9854 84.8331 95.5816 84.8331 92.9857V89.0631C84.8331 86.9864 85.4676 86.2942 87.2559 87.2748L106.408 97.716C107.792 98.5236 108.311 99.0427 108.311 100.6V103.485C108.311 105.042 107.792 105.619 106.408 106.427L87.2559 116.81Z"
			fill="#000A23"
		/>
	</svg>
);
